import FileType, { FileTypeType } from '@constants/fileType';

export default function getFileType(fileName: string): FileTypeType {
  if (fileName.startsWith('INSP_') || fileName.startsWith('SI_')) {
    return FileType.INSPECTION_SUMMARY;
  }
  if (fileName.startsWith('OBS_') || fileName.startsWith('NC_')) {
    return FileType.ACTION_SUMMARY;
  }
  if (fileName.endsWith('.pdf')) {
    return FileType.REPORT;
  }
  return FileType.UNKNOWN;
}
